import React, { useState, useEffect } from "react";
import "./Login.css";
import { useNavigate } from "react-router-dom";

const Login = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [Credienticals, setCredienticals] = useState({});
  const navigate = useNavigate();

  const validateLogin = async (event) => {
    event.preventDefault();
    const apiUrl = `${process.env.REACT_APP_BASEURL}/apis/auth.php`;
    try {
      const formData = new FormData();
      formData.append("userid", username);
      formData.append("password", password);

      const response = await fetch(apiUrl, {
        method: "POST",
        body: formData,
      });
      const data = await response.json();
      setCredienticals(data);
      if (data.message === "Login successful") {
        const userDetails = {
          username: data.user_name,
          userid: data.user_id,
          role: data.role,
          id: data.id,
          state: data.state,
          client_name: data.client_name,
        };
        localStorage.setItem("userdetails", JSON.stringify(userDetails));
        if (
          data.role === "cadmin" ||
          data.role === "vendor" ||
          data.role === "employee" ||
          data.role === "manager"||
          data.role === "sadmin" ||
          data.role === "client" ||
          data.role === "hr" ||
          data.role === "hrm"
        ) {
          navigate("/Admin", { state: { fromLogin: true } });
        } else {
          alert("Invalid role");
        }
      } else {
        alert(data.message);
      }
    } catch (error) {
      console.error("Error during login:", error);
    }
  };

  const handleforgot = () => {
    navigate("/Forgot");
  };

  const handlesignup = () => {
    navigate("/signup");
  };

  useEffect(() => {
    console.log(Credienticals);
  }, [Credienticals]);

  return (
    <div className="wrapper">
    <div className="login-page">
      <div class="container1">
        <div class="cards">
          <div class="card card-1">
            <div class="card__content">
              <div class="login-box">
                <form onSubmit={validateLogin}>
                  <h2 className="loginh2">Sign In</h2>
                  <div class="input-box">
                    <span class="icon">
                      <ion-icon name="mail"></ion-icon>
                    </span>
                    {/* <input type="email" required/> */}
                    <input
                      value={username}
                      onChange={(e) => setUsername(e.target.value)}
                      required
                    />
                    <label>User ID</label>
                  </div>

                  <div class="input-box">
                    <span class="icon">
                      <ion-icon name="lock-closed"></ion-icon>
                    </span>

                    <input
                      type="password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      required
                    />
                    <label>Password</label>
                  </div>

                  <div class="remember-forgot">
                    <label> </label>
                    {/* <a href="#">Forgot Password?</a> */}
                    <span onClick={handleforgot}>Forgot Password?</span>
                  </div>

                  <button className="loginbutton">Login</button>
                </form>
              </div>

              <label>
                Try our demo{" "}
                <strong className="signup" onClick={handlesignup}>
                  {" "}
                  Sign Up{" "}
                </strong>
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
     </div>
  );
};

export default Login;
